import { Link } from "gatsby"
import React from "react"

const Header = () => (
  <header className="header">
    <div className="circle">
      <Link to="/">fb</Link>
    </div>
  </header>
)

export default Header
